/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from 'react'
import { CookiesProvider } from 'react-cookie'

import * as rainbowStyles from '@rainbow-me/rainbowkit/styles.css'
import './src/styles/global.css'

// import '@JediSignals/fe_core_ui_library/globals.css'

export const wrapRootElement = (props) => {
  return <CookiesProvider>{props.element}</CookiesProvider>
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.pathname === '/nft') {
    window.scrollTo(0, 0)
    return false
  }
  return true
}
